import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { SwiperSlide } from 'swiper/react';
import { Product } from 'types/Products';
import { MoreThumps, PresentImage, ThumpSlider, ThumpSLideWrapper } from './ProductMedia.styled';
type Props = {
  data: Product;
};
export default function ProductMedia({ data }: Props) {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const { locale } = useRouter();
  return (
    <div>
      <PresentImage
        spaceBetween={8}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
        dir={'ltr'}
      >
        {data.images.map((src, index) => (
          <SwiperSlide key={index}>
            <Image layout="fill" objectFit="contain" src={src.url} alt="media image" priority={true} />
          </SwiperSlide>
        ))}
      </PresentImage>
      <ThumpSLideWrapper>
        <ThumpSlider
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          slidesPerView={6}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper"
          breakpoints={{
            1200: {
              slidesPerView: 4,
              spaceBetween: 8,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 8,
            },
          }}
        >
          {data.images.map((src, index) => (
            <SwiperSlide key={index}>
              <Image objectFit="contain" src={src.url} alt="media image" width={46} height={46} priority={true} />
            </SwiperSlide>
          ))}
        </ThumpSlider>
        {data.images.length > 6 && <MoreThumps>+{data.images.length - 6}</MoreThumps>}
      </ThumpSLideWrapper>
    </div>
  );
}
